import { render, staticRenderFns } from "./DeductibleTrackerFooter.vue?vue&type=template&id=c7c66d18&scoped=true"
import script from "./DeductibleTrackerFooter.vue?vue&type=script&lang=ts"
export * from "./DeductibleTrackerFooter.vue?vue&type=script&lang=ts"
import style0 from "./DeductibleTrackerFooter.vue?vue&type=style&index=0&id=c7c66d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c66d18",
  null
  
)

export default component.exports